module.exports = __webpack_public_path__ + "img/strinburg.1ee34594.png";